import React, { Component } from 'react';


class PageHeader extends Component {
  render() {
      return (
        <div class="page-header border-bottom-0">
          <div class="page-header-content header-elements-md-inline">
            <div class="page-title d-flex">
              <h4><span class="font-weight-semibold">{this.props.pageTopic}</span></h4>
              <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
            </div>

              {/*<!-- <div class="header-elements d-none text-center text-md-left mb-3 mb-md-0">
              <a href="#" class="btn btn-labeled btn-labeled-right bg-primary">Button <b><i class="icon-menu7"></i></b></a>
            </div> -->*/}
          </div>
        </div>
	     )
  }
}

export default PageHeader;
